// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Catalog{position:relative}.Catalog--search{margin-top:1rem}.Catalog--search.Catalog--searchProducts.Catalog--noSubCategories>.ContentHeader,.Catalog:not(.Catalog--search).Catalog--noSubCategories>.ContentHeader{margin-bottom:1rem}.Catalog__productsCounter{color:#606060;font-size:.8125rem}@media(max-width:767.98px){.Catalog__productsWrapper>.row>div[class*=col-]:last-child:after{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
